import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router";

import { refetchCustomer } from "../queries/global";

import LoadingIndicator from "./loading-indicator";

export default function Iframe(props) {
  const params = useParams();

  const iframeRef = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const onMessage = (event) => {
      if (!iframeRef.current) return;

      const sourceWindow =
        iframeRef.current.contentWindow ||
        iframeRef.current.contentDocument?.defaultView;
      if (event.source !== sourceWindow) return;

      if (typeof event.data === "string" && event.data.startsWith("resize:")) {
        const newHeight = Number(event.data.slice(7));
        if (!isNaN(newHeight)) {
          // setHeight(newHeight + 15); // Extra padding
          setHeight(prev => {
            const target = newHeight + 20;
            if(Math.abs(prev - target) < 25) return prev;
            return target;
          })
        }
      }

      if (event.data?.type === "navigate") {
        if (event.data.book_online && params.instanceId) {
          window.location.href = `/book-online/${params.instanceId}`;
        } else {
          window.location.href = event.data.url;
        }
      }

      if (event.data?.type === "update_session") {
        refetchCustomer();
      }
    };

    window.addEventListener("message", onMessage);
    return () => {
      window.removeEventListener("message", onMessage);
    };
  }, []);

  return (
    <>
      {props.hasLoader && height === 0 && <LoadingIndicator type="page" />}

      <iframe
        ref={iframeRef}
        name="SpektrixIFrame"
        id="SpektrixIFrame"
        frameBorder="0"
        src={props.url}
        title={props.title}
        style={{
          height: height + "px",
          minHeight: height + "px",
          width: "100%",
        }}
        allow="local-network-access"
      />
    </>
  );
}
